// File Metadata:
// Filename: DashLayout.js
// Version: 1.00
// Created: 2022-09-28 23:40:54
// Last Modified: 2025-04-01 16:55:19
// Authors: [Your Name]
// Description: A brief summary of what this file does

import { useEffect } from 'react'
import { Outlet, useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { selectCurrentToken } from '../features/auth/authSlice'
import DashFooter from './DashFooter'
import DashHeader from './DashHeader'
import DrawerNav from './DrawerNav'

const DashLayout = () => {
    const token = useSelector(selectCurrentToken)
    const navigate = useNavigate()

    useEffect(() => {
        if (!token) {
            navigate('/login')
        }
    }, [token, navigate])

    return (
        <>
            <div className='dash-container'>
                <Outlet />
            </div>
            <DashFooter />
        </>
    )
}

export default DashLayout
